import { APIRes, CallMethodEnums } from '@/types/api';
import { GetTracesArgs, TracesApiRes } from '@/types/traces';
import { envVarsProvider } from '@/utils/envVars/envVars';

import { call } from './utils';

export const tracesGet = async( args: GetTracesArgs ): Promise<TracesApiRes> => {
  if ( envVarsProvider.get( 'UI_TRACING_DISABLED' ) ) {
    return {} as TracesApiRes; // TODO: use this during dev to avoid datadog rate limiting until error handling is better
  }

  // service:agent_service @traceloop.association.properties.agent_name:haiku
  const json = call<unknown, TracesApiRes>( {
    body: {
      agent_id: args.agentId,
      agent_version: args.version
    },
    isProtected: true,
    method: CallMethodEnums.POST,
    resHandler: async( res: APIRes<TracesApiRes> ) => {
      console.log( res );
      // if( !res.ok ) {
      //   throw Error( `${ res.status }-${ res.statusText }: ${ ( ( await res.json() as TracesApiRes ).errors ).join( ',' ) }` );
      // }
    },
    route: '/api/traces'
  } );

  return json;
};
